import { render, staticRenderFns } from "./denglongshu.vue?vue&type=template&id=a9354bfc&scoped=true&"
import script from "./denglongshu.vue?vue&type=script&lang=js&"
export * from "./denglongshu.vue?vue&type=script&lang=js&"
import style0 from "./denglongshu.vue?vue&type=style&index=0&id=a9354bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9354bfc",
  null
  
)

export default component.exports